import Avatar from '@mui/material/Avatar'
import Chip from '@mui/material/Chip'
import { useTheme } from '@mui/material/styles'
import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'
import React from 'react'

import { ReactComponent as CommercialIcon } from 'assets/business-line/Commercial.svg'
import { ReactComponent as ResidentialIcon } from 'assets/business-line/Residential.svg'
import { ReactComponent as RolloffIcon } from 'assets/business-line/Rolloff.svg'
import { BUSINESS_LINE_TYPE, BUSINESS_LINE_TYPE_TO_COLOR_MAP } from 'settings/constants/businessLine'
import { ALPHA_38_PERCENT } from 'theme/colors'
import { get } from 'utils/lodash'

const { RESIDENTIAL, COMMERCIAL, ROLL_OFF } = BUSINESS_LINE_TYPE

export const BUSINESS_LINE_TYPE_TO_SVG = {
  [RESIDENTIAL]: ResidentialIcon,
  [COMMERCIAL]: CommercialIcon,
  [ROLL_OFF]: RolloffIcon,
}

const BusinessLineChip = ({ businessLineType = '', businessLineName }) => {
  const theme = useTheme()
  const Icon = get(BUSINESS_LINE_TYPE_TO_SVG, businessLineType)
  const backgroundColor = get(BUSINESS_LINE_TYPE_TO_COLOR_MAP, businessLineType)

  return businessLineName ? (
    <Chip
      avatar={
        Icon ? (
          <Avatar
            sx={{
              backgroundColor: `${theme.palette.background.black}${ALPHA_38_PERCENT}`,
            }}
          >
            <SvgIcon inheritViewBox sx={{ fontSize: 14, color: theme.palette.background.paper }}>
              <Icon />
            </SvgIcon>
          </Avatar>
        ) : null
      }
      label={businessLineName}
      size="small"
      sx={{ ...(backgroundColor && { backgroundColor, color: theme.palette.getContrastText(backgroundColor) }) }}
    />
  ) : (
    ''
  )
}

BusinessLineChip.propTypes = {
  businessLineType: PropTypes.string,
  businessLineName: PropTypes.string,
}

export default BusinessLineChip
